
class ThrottleLimitExceededError extends Error {
    constructor(message: string) {
      super(message);
      Object.setPrototypeOf(this, ThrottleLimitExceededError.prototype);
    }
  }
  
  export default ThrottleLimitExceededError
